import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeo, indexRobots, noindexRobots, siteOrigin, structuredData } from '../../shared/seo';
import { legalCatalog } from '../lib/legal';

export function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const seo = getSeo(pathname);
    const index = seo.index && legalCatalog.ready && import.meta.env.MODE !== 'preview';
    document.title = seo.title;
    function meta(attribute: 'name' | 'property', name: string, content: string) {
      let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
      element.content = content;
    }
    meta('name', 'description', seo.description);
    meta('name', 'robots', index ? indexRobots : noindexRobots);
    meta('property', 'og:title', seo.title); meta('property', 'og:description', seo.description);
    meta('property', 'og:type', seo.type || 'website'); meta('property', 'og:site_name', 'Przed rejsem'); meta('property', 'og:locale', 'pl_PL');
    meta('property', 'og:image', siteOrigin + (seo.image || '/brand/hero.png'));
    meta('name', 'twitter:card', 'summary_large_image'); meta('name', 'twitter:title', seo.title);
    meta('name', 'twitter:description', seo.description); meta('name', 'twitter:image', siteOrigin + (seo.image || '/brand/hero.png'));
    document.head.querySelectorAll('link[rel="canonical"],meta[property="og:url"],script[data-seo]').forEach(element => element.remove());
    if (seo.canonical) {
      const link = document.createElement('link'); link.rel = 'canonical'; link.href = seo.canonical; document.head.appendChild(link);
      meta('property', 'og:url', seo.canonical);
    }
    if (index) for (const data of structuredData(pathname)) {
      const script = document.createElement('script'); script.type = 'application/ld+json'; script.dataset.seo = 'true'; script.textContent = JSON.stringify(data); document.head.appendChild(script);
    }
  }, [pathname]);
  return null;
}
